export default __webpack_public_path__ + "static/testimonial-ashley-27cc1e418617110feebffe1b6d6180a0.png";